'use strict';
const angular = require('angular');

export class serviceRequestInfoComponent {
  /*@ngInject*/
  constructor(Auth, dialogs, prompt, IntegrationService) {
    this.Auth = Auth;

    this.userId = this.Auth.getCurrentUserSync()._id;
    this.IntegrationService = IntegrationService;

    this.dialogs = dialogs;
    this.prompt = prompt;
  }

  $onInit() {
    this.ticket = this.resolve.config.ticket;

    this.title = this.ticket.code + ": " + this.ticket.name;
  };

  ok() {
    this.close({$value: ''});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  addNote() {
    this.prompt({
      title: 'Add Note',
      message: 'Add your note below',
      input: true,
      label: '',
      value: ''
    }).then(note => {

      let noteObj = {
        note: note,
        meta: {
          creationUser: this.userId
        }
      };

      this.IntegrationService.patchServiceRequest({id: this.ticket._id}, [
        { "op": "add", "path": "/notes/-", "value": noteObj },
      ], data => {
        this.ticket.notes.push(noteObj);
      });
    });
  }

  deleteNote(idx) {
    var dlg = this.dialogs.confirm("Delete Note?", "Do you really want to delete your note?<br/><br/>" + this.ticket.notes[idx].note);
    dlg.result.then(() => {
      this.IntegrationService.patchServiceRequest({id: this.ticket._id}, [
        { "op": "remove", "path": "/notes/"+idx },
      ], data => {
        this.ticket.notes.splice(idx,1);
      });
    },() => {
    });
  }

  getTextHtml(text) {
    return (text) ? text.replace(/(?:\r\n|\r|\n)/g, '<br />') : "";
  }

}

export default angular.module('conduuApp.serviceRequestInfoComponent', [])
  .component('serviceRequestInfoComponent', {
    template: require('./service-request-info.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: serviceRequestInfoComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/service-request-info/service-request-info.component.js